import type { RootState } from '../index'

export const selectAnalysisState = (state: RootState) => state.analysis

export const selectAnalysisByDocumentId = (documentId: string) => 
  (state: RootState) => state.analysis.byDocumentId[documentId]

export const selectSelectedAnalysis = (state: RootState) => {
  const { selectedDocumentId, byDocumentId } = state.analysis
  if (!selectedDocumentId) return null
  return byDocumentId[selectedDocumentId] || null
}

export const selectAnalysisStatus = (documentId: string) =>
  (state: RootState) => state.analysis.byDocumentId[documentId]?.status || 'pending'

